import React from "react";
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';import AsyncPage from "./async";

export default [
  <DefaultConsumerLayout
    key="/consumer/features/ai-video-editor"
    exact
    path="/consumer/features/ai-video-editor"
    component={AsyncPage}
  />,
];